var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13261_49994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 30.6894L13.2266 25.2731L25.1557 13.0913L30.9066 18.7277L18.7812 30.6894Z",
    fill: "#8AB4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8062 6.74218L13.272 1.09131L1.17 13.0786C-0.39 14.6386 -0.39 17.1677 1.17 18.7294L13.09 30.7277L18.7262 25.4549L9.6445 15.9041L18.8062 6.74218Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8276 13.1713L18.8276 1.17131C17.2659 -0.390437 14.7331 -0.390437 13.1714 1.17131C11.6096 2.73306 11.6095 5.26594 13.1714 6.82781L25.1714 18.8278C26.7331 20.3896 29.2659 20.3896 30.8276 18.8278C32.3894 17.2661 32.3895 14.7331 30.8276 13.1713Z",
    fill: "#8AB4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9091 32.0004C18.0681 32.0004 19.8182 30.2502 19.8182 28.0913C19.8182 25.9323 18.0681 24.1821 15.9091 24.1821C13.7502 24.1821 12 25.9323 12 28.0913C12 30.2502 13.7502 32.0004 15.9091 32.0004Z",
    fill: "#246FDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13261_49994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTag);
export default __webpack_public_path__ + "static/media/GoogleTag.540373a6b7e6b938fcac8eb1f852d46f.svg";
export { ForwardRef as ReactComponent };